import { DOW, isoWeek, isWeekend, MONTHS_FULL, pad } from './calendar';
import { center, COL, fill, forEachDay, ROW } from './layout';

function writeLabels(ws, year, personName) {
  ws.getCell(ROW.TITLE, 1).value = year;
  ws.getCell(ROW.TITLE, 1).font = { bold: true, size: 16 };
  ws.getCell(ROW.TOTAL, 1).value = `Total — ${personName}`;
  ws.getCell(ROW.TOTAL, 1).font = { bold: true };
  ws.getCell(ROW.FERIE, 1).value = 'Fériés';
  ws.getCell(ROW.WEEK, 1).value = 'Semaines';
  ws.getCell(ROW.WEEK, 1).font = { bold: true };
  ws.getCell(ROW.WEEK, 1).fill = fill(COL.week);
}

// Bande du mois (ligne 1) fusionnée sur les jours, et initiale du mois dans la gouttière.
function writeMonthBand(ws, mo) {
  ws.mergeCells(ROW.TITLE, mo.firstDay, ROW.TITLE, mo.lastDay);
  const cells = [
    [ws.getCell(ROW.TITLE, mo.firstDay), MONTHS_FULL[mo.m]],
    [ws.getCell(ROW.TITLE, mo.gutter), MONTHS_FULL[mo.m][0]],
  ];
  for (const [cell, value] of cells) {
    cell.value = value;
    cell.font = { bold: true };
    cell.alignment = center();
    cell.fill = fill(COL.month);
  }
}

function writeDay(ws, { dt, c, d, ferie }) {
  const we = isWeekend(dt);
  ws.getCell(ROW.DOW, c).value = DOW[dt.getDay()];
  ws.getCell(ROW.DAY, c).value = d;
  for (const r of [ROW.DOW, ROW.DAY]) {
    ws.getCell(r, c).alignment = center();
    ws.getCell(r, c).font = { size: 8, color: { argb: we ? 'FF999999' : 'FF333333' } };
  }
  // Fériés : marqueur F
  if (ferie) {
    const f = ws.getCell(ROW.FERIE, c);
    f.value = 'F';
    f.alignment = center();
    f.font = { bold: true, size: 8, color: { argb: 'FF538135' } };
  }
  // Semaines : numéro le lundi
  if (dt.getDay() === 1) {
    const w = ws.getCell(ROW.WEEK, c);
    w.value = 'S' + pad(isoWeek(dt));
    w.alignment = center();
    w.font = { size: 7, bold: true };
  }
}

/* Titre, libellés de lignes, en-têtes de mois et de jours. */
export function writeHeader(ws, { year, personName, months, dateCol, feries }) {
  writeLabels(ws, year, personName);
  for (const mo of months) {
    writeMonthBand(ws, mo);
    forEachDay(year, mo, dateCol, (iso, dt, c, d) =>
      writeDay(ws, { dt, c, d, ferie: feries.has(iso) }),
    );
  }
}
